import Components from "./components";
import {routerConfig} from "./RouterConfig";
import {TradingSystemsService} from "./service/TradingSystemsService";
import {tradingSystemsView, TradingSystemsView} from "./view/TradingSystemsViewComponent";
import {TradingSystemsDialogService} from "./service/TradingSystemsDialogService";

export default angular.module("tfApp.trading-systems", [Components])
                      .config(routerConfig)
                      .component(TradingSystemsView, tradingSystemsView())
                      .service(TradingSystemsService.id, TradingSystemsService)
                      .service(TradingSystemsDialogService.id, TradingSystemsDialogService)
                      .name;
